<template>

    <div class="experts-area">
        <h4 class="grey-title">Meet our Experts</h4>

        <div class="flex flex-between">

            <article v-for="(i,k) in experts" :key="k" style="display: flex; flex-wrap: wrap; row-gap: 20px;">
               <div class="name-title" style="flex-basis: 100%;">
                    <h5>{{i.title}}</h5>
                    <p class="title">{{i.data.position}}</p>
               </div>
               <!-- <div style="flex-basis: 50%;"> -->
                   <div class="image small" style="flex-basis: 35%;">
                        <img :src="i.imagePath" :alt="i.title">
                    </div>
                    <div class="text small" style="flex-basis: 50%;">

                        <a v-if="i.data.link" :href="i.data.link" class="button blue-border small book-now">Book Now</a>
                        <a @click="viewBio(i)" class="button blue-border small">Read Bio</a>
                    </div>
               <!-- </div> -->
            </article>

        </div>

        <div class="popup-module modal" v-if="isOpen">
            <div @click="viewBio(null)" class="modal-background"></div>
            <div class="modal-content">
                <!-- <span class="close" @click="viewBio(null)">&times;</span> -->
                <span class="close" @click="viewBio(null)"><img src="/images/icons/close.svg"></span>
                <div class="flex-container">
                        <div class="image">
                            <a :href="getUrl(openPerson.title)">
                                <img class="popup-img" :src="openPerson.imageHeroPath" :alt="'Habit Health:' + openPerson.title">
                            </a>
                        </div>

                        <div class="content">

                            <div class="info">
                            <h2>{{ openPerson.title }}</h2>
                            <h4>{{ openPerson.data.position }}</h4>
                            <a :href="openPerson.data.link" class="button">Book Now</a>
                            </div>

                            <div class="wysiwyg" v-html="openPerson.data.content">

                            </div>

                        </div>
                </div>

            </div>
        </div>

    </div>


</template>

<script>
  export default {
    props: {
      experts: [Array, Object]
    },

    data: () => ({
        isOpen: false,
        openPerson: {}
    }),

    methods: {
      getUrl(name) {
          return '/about-us/meet-our-experts?expert=' + name
      },
      viewBio(model) {
          if (model === null) {
            this.openPerson = {}
          } else {
            this.openPerson = model
          }
          console.log(this.openPerson)
          this.isOpen = !this.isOpen
      }
    }
  }
</script>

<style scoped>
.modal {
  display: block; /* Hidden by default */
}

.modal-background {
    position: fixed; /* Stay in place */
    z-index: 9997; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: fixed;
  left: auto;
  right: auto;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999; /* Sit on top */
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  /* width: 80%; */
  max-width: 1170px;
  width: calc(100% - 40px);
  height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;

    @media (min-width: 768px) {
        height: fit-content;
    }

    @media (min-width: 1024px) {
        top: 100px;
        transform: none;
        overflow: hidden;
    }

    @media (min-width: 1215px) {
        width: 100%;
        max-height: 485px;
    }
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.flex-container {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;

    @media (min-width: 768px) {
        flex-wrap: nowrap;
    }
}
.image {
    /* float: left; */
    width: 100%;

    &.small { margin-right: 30px; }

    @media (min-width: 768px) {
        max-width: 290px;
    }
}
.content {
    /* float: right; */
    width: 100%;
}
.wysiwyg {
    margin-top: 38px;
    /* overflow: auto; */

    @media (min-width: 768px) {
        height: 210px;
        overflow: auto;
    }
}
.name-title p.title {
    line-height: 15px;
    font-size: 16px;
    margin-bottom: 0;
}
.name-title h5 {
    line-height: 0;
    margin-top: 12px;
}
.book-now {
    margin-bottom: 11px;
    background: #054c72 !important;
    border-color: #054c72 !important;
    color: #fff !important;
}
.info h2 {
    line-height: 12px;
    margin-top: 20px;
}
.info h4 {
    color: #657781;
    font-family: proxima-nova, "Arial", "Helvetica Neue", "Helvetica", sans-serif;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.2px;
    line-height: 30px;
    /* margin-bottom: 25px; */
}
.popup-img {
    display: block;
    /* max-width: 100%; */
    width: 100%;
    object-fit: contain;
    object-position: top;

    @media (min-width: 450px) {
        width: 60%;
        max-width: 60%;
    }

    @media (min-width: 768px) {
        // height: 60%;
        max-width: unset;
        object-fit: cover;
    }
}
</style>




// WEBPACK FOOTER //
// resources/assets/frontend/js/components/LocationExpert.vue